<template>
    <section class="items-wrap">
        <header class="all-100 align-left">
            <h1>
                <a class="logo push-left" href="https://estrelasemcasa.foxtv.pt/" target="_blank">FOX</a>
            </h1>
        </header>
        <div class="column-group">
            <div class="all-100 form-container">
                <form id="form" action="#" class="ink-form column-group gutters">
                    <div class="questio0-bg" hidden>
                        <fieldset class="all-100">
                            <legend class="login-success">Olá, <b class="user-name"></b></legend>
                            <legend class="login-error">A fox diz:</legend>
                            <div class="control-group">
                                <p class="label login-error">Para poder usar a sua conta Spotify, é necessário que se autentique</p>
                            </div>
                        </fieldset>
                    </div>
                    <Question 
                        v-for="(question, index) in questions"
                        :question-group="question"
                        :key="index" 
                        :idx="index"
                        :questions-length="questions.length"
                        :step="step"
                        @onNextStep="nextStep($event)"
                        @onSubmit="submit($event)">
                    </Question>                        
                    <div class="questio0-bg" hidden>
                        <fieldset class="all-100" id="error">
                            <div class="align-center">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            </div>
                            <legend class="align-center">Oops... Ocorreu um erro.</legend>
                            <div class="control-group">
                                <p class="label align-center">Tentamos de novo?</p>
                            </div>
                        </fieldset>
                    </div>
                </form>
            </div>
        </div>
    </section>  
</template>

<script>
import appConfig from "@/app.config";
import SpotifyService from "@/services/spotify.service";
import AnalyticsService from '@/services/analytics.service';

export default {
    name: "Quiz",
    data() {
        return {
            playlist: null,
            tracks: [],
            step: 1,
            questions: appConfig.questions,
            chosenOptions: [],
            result: '',
        };
    },
    created() {
        window.location.hash = this.step;
        AnalyticsService.pageView(this.step);
    },
    methods: {
        nextStep(answer) {
            this.chosenOptions.push(answer);
            this.step = this.step + 1;
            window.location.hash = this.step;
            AnalyticsService.pageView(this.step);
        },
        submit() {
            let hits = this.chosenOptions.reduce((arr, option) => {
                let multipleOptions = option.split(',');
                multipleOptions.forEach(multipleOption => {
                    arr[multipleOption] = arr[multipleOption]  === undefined ? 1 : arr[multipleOption] + 1
                });
                return arr;
            },{});

            this.result = Object.keys(hits).reduce((a, b) => hits[a] > hits[b] ? a : b);
            let token = JSON.parse(localStorage.getItem(appConfig.COOKIE_AUTH));  

            SpotifyService.getUserInfo()
                .then(([user]) => this.goToPlaylist(user.id, token))
                .catch(() => this.goToPlaylist('dj-sapo', token))
        },
        goToPlaylist(user, token) {
            this.$router.push({ 
                path: `playlist/${user}/${this.result}`, 
                params: { 
                    access_token: token ? token.access_token : undefined, 
                }
            })         
        }
    },
    watch: {
        $route: function(to, from){
            let hashFrom = parseInt(from.hash.split('#')[1]);
            let hashTo = parseInt(to.hash.split('#')[1]);
            hashTo ? this.step = hashTo : this.step = 1;
            if(hashTo < hashFrom || isNaN(hashTo)) {
                this.chosenOptions.pop();
            }
        }
    }
};
</script>

<style lang="scss">
.result{
    span{
        display: block;
        text-transform: capitalize;
        padding: 30px;
        color: red;
        font-weight: 600;
    }
}
</style>

